export default __webpack_public_path__ + "static/summer_containers11-78c7e55c326737b5be0947b912daef35.webp";